import React from 'react';
import Button from '@ingka/button';
import SSRIcon from '@ingka/ssr-icon';
import { Container, Nav, Navbar } from 'react-bootstrap';
import {
  chevronDoubleLeftSmall,
  chevronDoubleRightSmall,
} from '@ingka/ssr-icon/icons';
import './TopNavbar.scss';
import { HelpSection } from './HelpSection';

type TopNavbarProps = {
  showSidebar: boolean;
  toggleSidebar: () => void;
};

export const TopNavbar: React.FC<TopNavbarProps> = ({
  showSidebar,
  toggleSidebar,
}) => {
  return (
    <Navbar variant="dark" expand="lg" className={'main-layout-navbar'}>
      <Container fluid>
        <Button size="small" onClick={toggleSidebar} className="nav-button">
          <SSRIcon
            paths={
              showSidebar ? chevronDoubleLeftSmall : chevronDoubleRightSmall
            }
            color={'white'}
            style={{ cursor: 'pointer' }}
          />
        </Button>

        <Navbar.Brand href="#home">Unit Operations Reporting</Navbar.Brand>

        <Navbar.Collapse className="justify-content-end">
          <Nav.Link target="_#" href="https://exporter.uo-reporting.ingka.com/">
            AutoExporter
          </Nav.Link>
          <HelpSection />
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
